import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setBubbleInputFocus } from '../../actions/chat/actions';
import { sendWsAnswer } from '../../actions/wsAnswer';
import { BubbleInput } from '../../components/BubbleInput';
import { TMessageBubbleTextField } from '../../types/messageBubble';

type TBubbleInputContainerProps = {
  messageId: string;
  textField: TMessageBubbleTextField;
  analyticsBubbleType: string;
};

export const BubbleInputContainer: React.VFC<TBubbleInputContainerProps> = ({
  messageId,
  textField,
  analyticsBubbleType,
}) => {
  const [value, setValue] = React.useState<string>('');

  const { hint, buttonName, socketPayload, textFieldType } = textField;

  const dispatch = useDispatch();

  const handleChange = React.useCallback((value: string) => {
    setValue(value);
  }, []);

  const handleSend = React.useCallback(() => {
    const input = value.trim();

    if (input) {
      dispatch(sendWsAnswer({ messageId, payload: socketPayload, input, analyticsBubbleType }));
    }
  }, [analyticsBubbleType, dispatch, messageId, socketPayload, value]);

  const handleFocus = React.useCallback(() => {
    dispatch(setBubbleInputFocus({ isBubbleInputFocused: true }));
  }, [dispatch]);

  const handleBlur = React.useCallback(() => {
    dispatch(setBubbleInputFocus({ isBubbleInputFocused: false }));
  }, [dispatch]);

  return (
    <BubbleInput
      type={textFieldType}
      value={value}
      buttonName={buttonName}
      placeholder={hint}
      onChange={handleChange}
      onSend={handleSend}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};
